import { render, staticRenderFns } from "./UndoBar.vue?vue&type=template&id=785fc81b&scoped=true&"
import script from "./UndoBar.vue?vue&type=script&lang=js&"
export * from "./UndoBar.vue?vue&type=script&lang=js&"
import style0 from "./UndoBar.vue?vue&type=style&index=0&id=785fc81b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785fc81b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
